export default "__VITE_ASSET__BXillkQY__";